(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '@material-ui/core', '../../elements', '../../svg', '../../styles'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('@material-ui/core'), require('../../elements'), require('../../svg'), require('../../styles'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.core, global.elements, global.svg, global.styles);
    global.BrandBar = mod.exports;
  }
})(this, function (exports, _react, _core, _elements, _svg, _styles) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var silver = _styles.colors.silver,
      white = _styles.colors.white;


  var styles = void 0;

  var BrandBar = function BrandBar() {
    return _react2.default.createElement(
      _core.AppBar,
      { className: 'fixed-top', style: styles.navBar },
      _react2.default.createElement(
        'div',
        { tag: 'span', style: styles.logoContainer },
        _react2.default.createElement(_svg.PeachjarLogo, null)
      ),
      _react2.default.createElement(
        'ul',
        { className: 'navbar-nav ml-auto d-none d-sm-block' },
        _react2.default.createElement(
          'li',
          { className: 'nav-item' },
          _react2.default.createElement(_elements.CallUs, null)
        )
      )
    );
  };

  styles = {
    logoContainer: {
      width: '120px',
      marginLeft: '15px',
      marginBottom: '10px',
      display: 'flex',
      height: '100%',
      alignItems: 'center'
    },
    navBar: {
      backgroundColor: white,
      borderBottom: 'solid 2px ' + silver,
      height: '83px',
      boxShadow: 'none',
      flexDirection: 'row'
    }
  };

  exports.default = BrandBar;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/layout/BrandBar.js
// module id = 512
// module chunks = 0